// extracted by mini-css-extract-plugin
export default {"majorContainer":"card_majorContainer__xqGMh","imgContainer":"card_imgContainer__g2bHA","details":"card_details__CvGYU"};